$(document).ready(function(){
	waypoints.init();
});

window.waypoints = {

	scrollTop: 0,
	preserverMenu: false,

	init: function () {
		this.initProductTitle();
		this.initProductMenu();
		this.initDoplnkyMenu();
		this.initYoutube();

		waypoints.scrollTop = $(window).scrollTop();
		$(window).scroll(function(event){
			var st = $(this).scrollTop();
			if (st > waypoints.scrollTop){
				waypoints.onScrollDown();
			} else {
				waypoints.onScrollUp();
			}
			waypoints.scrollTop = st;
		});
	},

	initProductTitle: function () {
		var title = $('.product-detail .product__short__description h1');
		if(title.length) {
			$(".title--placeholder").html(title.html());
		}

		title.waypoint({
			handler: function(direction) {
				if(direction === "down") {
					$("body").addClass("product-title--snap")
				} else {
					$("body").removeClass("product-title--snap")
				}
			}
		})
	},

	initProductMenu: function () {
		var menu = $(".product__detail__menu");
		if(menu.length) {
			$(".menu--placeholder").append(menu.clone());

			menu.waypoint({
				handler: function(direction) {
					if(direction === "down") {
						$("body").addClass("product-menu--snap")
					} else {
						$("body").removeClass("product-menu--snap")
					}
				}
			})
		}
	},

	initDoplnkyMenu: function () {
		// var menu = $(".navigation-doplnky-box");
		// if(menu.length) {
		// 	$(".menu--placeholder").append(menu.clone());
		//
		// 	menu.waypoint({
		// 		handler: function(direction) {
		// 			if(direction === "down") {
		// 				$("body").addClass("product-menu--snap")
		// 			} else {
		// 				$("body").removeClass("product-menu--snap")
		// 			}
		// 		}
		// 	})
		// }

	},

	initYoutube: function () {
		$("#hp-menu").waypoint({
			handler: function(direction) {
				if(direction === "down") {
					youtube.stop();
				} else {
					youtube.resume();
				}
			}
		})
	},

	onScrollDown: function () {
		$("body").addClass("scroll--down");
		$("body").removeClass("scroll--up");
	},

	onScrollUp: function () {
		if(!waypoints.preserverMenu) {
			$("body").addClass("scroll--up");
			$("body").removeClass("scroll--down");
		}
	}
}